import { Button } from '@geberit/gdds';

// components
import { Translation } from 'components/Translation/Translation';

interface GddsLoadMoreButtonProps {
  handleLoadMore: () => void;
}

export default function GDDSLoadMoreButton({ handleLoadMore }: Readonly<GddsLoadMoreButtonProps>) {
  return (
    <Button key="button" symbol="Refresh" onClick={handleLoadMore} className="loadmore-button">
      <Translation id="web20_more_results" />
    </Button>
  );
}
